import API from './api.js'

export default {
    async getSelectedSamples(ids) {
        try {
            let response = await API.HTTPS.get('/measurements/selectedsamples?id=' + ids.join("&id=") + '&page=1&pagesize=100000')

            return { code: 0, data: response.data }
        }
        catch (e) {
            return { code: 1, data: null }
        }
    }
}